<template>
  <div>
    <div>
      <p  class="category" style="margin-bottom: 29px">留言管理</p>
    </div>
    <div>
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="所属分类">
          <el-select v-model="form.cateid" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>

    </div>
    <el-table
        id="table"
        :data="tableData"
        style="width: 100%">
      <el-table-column
          label="ID"
          width="80">
        <template slot-scope="scope">
          <span >{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="类型"
          width="180">
        <template slot-scope="scope">
          <span style="">{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="姓名"
          width="120"
      >
        <template slot-scope="scope">
          <span v-html="scope.row.name"></span>
        </template>
      </el-table-column>
      <el-table-column
          label="公司"
          >
        <template slot-scope="scope">
          <span style="">{{ scope.row.company }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="状态"
          width="180">
        <template slot-scope="scope">
          <span  :class="scope.row.status.color">{{ scope.row.status.value }}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="提交时间"
          width="180">
        <template slot-scope="scope">
          <span >{{ scope.row.create_time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="openCate(scope.row.id)">查看</el-button>
          <el-button
              size="mini"
              type="danger"
              @click="deleteCate(scope.$index,scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <Dialog  :id='id' :show.sync="dialogVisible" @dialogShowChange="dialogShowChange"></Dialog>
    <el-pagination
        layout="prev, pager, next"
        :page-size=10
        @current-change="getCate"
        :page-count="total"
    >
    </el-pagination>

  </div>
</template>
<script>
import axios from "axios";
import Dialog from "@/views/pages/getMessageView.vue"

export default {
  name: "MessageView",
  data() {
    return {
      form:{
        cateid:''
      },
      tableData: [],
      options:[
        {value:'',label:'所有类型'},
        {value:'1',label:'投诉或建议'},
        {value:'2',label:'咨询产品/技术问题'}
      ],
      id: '',
      dialogVisible: false,
      total:100
    }
  },
  components:{
    Dialog,
  },
  created() {
    this.getCate();
  },
  methods: {
    openCate(id){
      this.id = id
      this.dialogVisible =true
    },
    dialogShowChange(val){
      this.dialogVisible = val
    },
    onSubmit() {
      this.getCate()
    },
    getCate(page=1){
      var cateid = this.form.cateid
      var str = '?page='+page;
      if(cateid) str = str + "&cateid="+cateid
      axios.get('/api/Message/index.html'+str).then((res)=>{
        this.tableData = res.data.data;
        this.total = res.data.total
      });
    },
    deleteCate(index,row){
      let tdata = this.tableData;
      this.$confirm("是否确认删除","提示",{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
      }).then(function (){
        axios.delete('/api/Message/deleteMessage.html',{data:{id:row.id}}).then((res)=>{
          if(res.data.code == 200){
            tdata.splice(index, 1);
          }
          alert(res.data.msg)
        });
      }).catch(function (){

      })

    }
  }
};
</script>
<style>
.green{color:green}
.grey{color:grey}
</style>